<input type="file"
       (change)="onFileSelected($event)"
       accept="image/png, image/jpeg"
       #fileUpload>   
<div>
  <mat-icon class="image"
            *ngIf="!fileUrl && !showCropper"
            id="icon-file-input"
            (click)="fileUpload.click()"
            [title]="fileUploadAlt[0]"
            [ngClass]="{'animate': animateImage}">
    {{ icon }}
  </mat-icon>
  <mat-icon *ngIf="fileUrl && !showCropper" (click)="removeImage()" class="remove-image">close</mat-icon>
  <img id="image-file-input"
       class="image"
       *ngIf="fileUrl && !showCropper"
       [src]="fileUrl"
       (click)="fileUpload.click()"
       [alt]="fileUploadAlt[1]"
       [title]="fileUploadAlt[1]"
       [ngClass]="{'animate': animateImage}">
  <img id="image-file-input"
       class="image"
       *ngIf="showCropper"
       [src]="croppedImage"
       (click)="fileUpload.click()"
       [alt]="fileUploadAlt[1]"
       [title]="fileUploadAlt[1]"
       [ngClass]="{'animate': animateImage}">
       
  <image-cropper
    [style.display]="showCropper ? null : 'none'"
    [imageChangedEvent]="imageChangedEvent"
    [cropperMaxWidth]="800"
    [cropperMinWidth]="192"
    [aspectRatio]="1/1"
    (imageCropped)="imageCropped($event)"
    (imageLoaded)="imageLoaded()"></image-cropper>
  <div class="button-container">
    <button mat-raised-button *ngIf="showCropper" (click)="cancelCrop()"  color="warn">{{imageUploadLabels.saveLabel}}</button>
    <button mat-raised-button *ngIf="showCropper" (click)="saveImage()" color="primary">{{imageUploadLabels.cancelLabel}}</button>
  </div>
  <app-anchor id="file-input"
              (click)="fileUpload.click()">
    {{getFileUploadLabel()}}
  </app-anchor>
  <app-label isError>{{ this.imageError }}</app-label>
</div>
